import BaseApi from './BaseApi'

export default class FleetSettingsApi extends BaseApi {
    async getFleetSettings (fleetId) {
        return this.get(`/api/v1.0/fleetsSettings/${fleetId}`)
    }

    async updateFleetSettings (fleetId, settings) {
        return this.put(`/api/v1.0/fleetsSettings`, {
            fleetId,
            settings
        })
    }

    async getEventNotificationSettings (fleetId) {
        return this.get(`/api/v1.0/fleetsSettings/eventNotificationSettings/${fleetId}`)
    }

    async updateEventNotificationSettings (fleetId, settings) {
        return this.put(`/api/v1.0/fleetsSettings/eventNotificationSettings`, {
            fleetId,
            settings
        })
    }

    async getFleetsAlarmPipelinesSettings (deviceModelId, fleetId = null) {
        const request = new URLSearchParams()
        if (fleetId) request.append('fleetId', fleetId)
        return this.get(`/api/v1.0/fleetsSettings/alarmsPipelinesSettings/${deviceModelId}`, request)
    }

    async createFleetsAlarmPipelinesSettings (params = {
        deviceModelId: null,
        fleetId: null,
        pipeline: {
            type: null,
            alarmKey: null,
            eventType: null,
            eventClassification: null,
            channels: null,
            isOverriding: null
        }
    }) {
        return this.post(`/api/v1.0/fleetsSettings/alarmsPipelinesSettings/`, params)
    }

    async resetFleetsAlarmPipelinesSettings (params = {
        alarmKey: null,
        deviceModelId: null,
        fleetId: null
    }) {
        return this.put('/api/v1.0/fleetsSettings/alarmsPipelinesSettings/reset', params)
    }

    async getDeviceNotificationSettings (FleetId) {
        return this.get(`/api/v1.0/fleetsSettings/deviceNotificationSettings/${FleetId}`)
    }

    async updateDeviceNotificationSettings (settings) {
        return this.put('/api/v1.0/fleetsSettings/deviceNotificationSettings', {
            settings
        })
    }
}
